// Production redirect logic
export const onRouteUpdate = ({ location }) => {
  // Only apply redirect logic in production environment
  if (typeof window !== 'undefined' && ['development', 'production'].includes(process.env.NODE_ENV)) {
    const urlParams = new URLSearchParams(location.search);
    const company = urlParams.get('company');

    // Get redirect domain from environment variable
    const redirectDomain = process.env.GATSBY_CSAT_DOMAIN || 'https://csat.pnj.io';

    // If company parameter is NOT 'cao', redirect to configured domain
    if (company !== 'cao') {
      // Preserve current path and search params for the redirect
      const currentPath = location.pathname;
      const currentSearch = location.search;
      const redirectUrl = `${redirectDomain}${currentPath}${currentSearch}`;

      console.log('🚀 Redirecting to:', redirectUrl);

      // Perform the redirect
      window.location.replace(redirectUrl);
    } else {
      console.log('✅ Bypass - company=cao detected');
    }
  } else {
    console.log('❌ Redirect skipped - not in development/production environment');
  }
};

// Optional: Handle initial page load as well
export const onInitialClientRender = () => {
  // Only apply redirect logic in production environment
  if (typeof window !== 'undefined' && ['development', 'production'].includes(process.env.NODE_ENV)) {
    const urlParams = new URLSearchParams(window.location.search);
    const company = urlParams.get('company');

    // Get redirect domain from environment variable
    const redirectDomain = process.env.GATSBY_CSAT_DOMAIN || 'https://csat.pnj.io';

    // Debug logging
    console.log('🔍 onInitialClientRender - Debug Info:');
    console.log('NODE_ENV:', process.env.NODE_ENV);
    console.log('GATSBY_CSAT_DOMAIN:', process.env.GATSBY_CSAT_DOMAIN);
    console.log('Redirect domain:', redirectDomain);
    console.log('Current URL:', window.location.href);
    console.log('Company parameter:', company);
    console.log('Should redirect?', company !== 'cao');

    // If company parameter is NOT 'cao', redirect to configured domain
    if (company !== 'cao') {
      // Preserve current path and search params for the redirect
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      const redirectUrl = `${redirectDomain}${currentPath}${currentSearch}`;

      console.log('🚀 Redirecting to:', redirectUrl);

      // Perform the redirect
      window.location.replace(redirectUrl);
    } else {
      console.log('✅ Bypass - company=cao detected');
    }
  } else {
    console.log('❌ Redirect skipped - not in development/production environment');
  }
}; 